import React, { useState, useEffect } from "react";
import usePost from "Hooks/usePost";
import { createsiefiles, getFileCategoryWithoutContent } from "API/swesum";
import Textfield from "Components/UI/Form/Textfield";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import DownloadIcon from "@mui/icons-material/Download";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Link as RouterLink } from "react-router-dom";

export default function WorkflowCreatesiefiles() {
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [summary, setSummary] = useState([]);
  const { openSuccess, openError } = usePopupNotificationContext();

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await getFileCategoryWithoutContent("BOKFÖRING");
        setSummary(response.data);
      } catch (error) {
        console.error("Failed to fetch files:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFiles();
  }, [file]);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setToDate(today);
  }, []);

  const createsiefilesReq = usePost({
    mtnFunc: () => createsiefiles(toDate),
    onError: (res) => {
      console.error(res);
      openError(
        `Något gick fel, ${res.Message !== null ? res.Message : res}`,
        10000
      );
      setLoading(false);
    },
    onSuccess: (res) => {
      openSuccess(res.Message, 2500);
      setLoading(false);
      setFile(res.Data);
    },
  });

  const downloadFile = () => {
    if (file && file.Content) {
      console.log(file);
      const byteCharacters = atob(file.Content);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray]);
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = file.Name;
      link.click();

      URL.revokeObjectURL(url);
    }
  };

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        padding: "1rem",
        gap: "1rem",
      }}
    >
      <Textfield
        fullWidth
        label="Datum (YYYY-MM-DD)"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
      />

      <LoadingButton
        onClick={() => {
          setLoading(true);
          createsiefilesReq.post();
        }}
        variant="contained"
        disabled={!toDate}
        loading={loading}
        startIcon={<PlayArrowIcon />}
      >
        Skapa SIE Export
      </LoadingButton>
      {file != null ? (
        <>
          <Button
            color="success"
            variant="contained"
            onClick={() => downloadFile()}
            startIcon={<DownloadIcon />}
          >
            Ladda ned {file.Name}
          </Button>

          <Box
            sx={{
              flex: 1,
              maxHeight: 1000,
              overflow: "auto",
              backgroundColor: "#f5f5f5",
              padding: 2,
              borderRadius: 1,
              fontFamily: "monospace",
              whiteSpace: "pre-wrap",
            }}
          >
            <Typography variant="body2">{atob(file.Content)}</Typography>
          </Box>
        </>
      ) : null}

      <Paper
        sx={{
          position: "absolute",
          top: 0,
          right: "-19.5rem",
          p: 2,
          minWidth: "300px",
          maxWidth: "300px",
        }}
      >
        <Typography variant="body2">Senast skapade</Typography>
        <List>
          {summary.slice(0, 10).map((file) => {
            return (
              <ListItem
                key={file.Id}
                component={RouterLink}
                to={`/files/${file.Id}`}
              >
                <ListItemText
                  primary={
                    <Typography variant="subtitle2" fontWeight="bold">
                      {file.Name}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body2" color="textSecondary">
                      {file.CreateTime}
                    </Typography>
                  }
                />
              </ListItem>
            );
          })}

          {summary.length - 10 > 0 && (
            <ListItem>
              <ListItemText
                primary={
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    fontStyle="italic"
                  >
                    + {summary.length - 10} st fler filer...
                  </Typography>
                }
              />
            </ListItem>
          )}
        </List>
      </Paper>
    </div>
  );
}
